const menuItems = {
    items: [
        {
            id: 'navigation',
            title: 'Home',
            type: 'group',
            userTypes: ['USER', 'ADMIN'],
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    userTypes: ['USER', 'ADMIN'],
                    url: '/app/dashboard/default',
                    icon: 'feather icon-home'
                }
            ]
        },
        {
            id: 'accounts',
            title: 'Accounts',
            type: 'group',
            userTypes: ['USER', 'ADMIN'],
            icon: 'icon-navigation',
            children: [
                {
                    id: 'accounts-table',
                    title: 'Accounts List',
                    type: 'item',
                    userTypes: ['USER', 'ADMIN'],
                    url: '/accounts/table',
                    icon: 'feather icon-file-text'
                }
            ]
        },
        {
            id: 'trades',
            title: 'Trades',
            type: 'group',
            userTypes: ['USER', 'ADMIN'],
            icon: 'icon-navigation',
            children: [
                // {
                //     id: 'add-trade',
                //     title: 'Add Trade',
                //     type: 'item',
                //     userTypes: ['USER', 'ADMIN'],
                //     url: '/trades/add',
                //     icon: 'feather icon-plus-square'
                // },
                // {
                //     id: 'active-trades',
                //     title: 'Active Trades',
                //     type: 'item',
                //     userTypes: ['USER', 'ADMIN'],
                //     url: '/trades/active',
                //     icon: 'feather icon-edit'
                // },
                {
                    id: 'history',
                    title: 'Trades',
                    type: 'item',
                    userTypes: ['USER', 'ADMIN'],
                    url: '/trades/list',
                    icon: 'feather icon-file-text'
                }
            ]
        },
        {
            id: 'ui-element',
            title: 'UI ELEMENT',
            type: 'group',
            userTypes: ['ADMIN'],
            icon: 'icon-ui',
            children: [
                {
                    id: 'basic',
                    title: 'Components',
                    type: 'collapse',
                    userTypes: ['ADMIN'],
                    icon: 'feather icon-box',
                    children: [
                        {
                            id: 'button',
                            title: 'Button',
                            type: 'item',
                            userTypes: ['ADMIN'],
                            url: '/basic/button'
                        },
                        {
                            id: 'badges',
                            title: 'Badges',
                            type: 'item',
                            userTypes: ['ADMIN'],
                            url: '/basic/badges'
                        },
                        {
                            id: 'breadcrumb',
                            title: 'Breadcrumb',
                            type: 'item',
                            userTypes: ['ADMIN'],
                            url: '/basic/breadcrumb'
                        },
                        {
                            id: 'collapse',
                            title: 'Collapse',
                            type: 'item',
                            userTypes: ['ADMIN'],
                            url: '/basic/collapse'
                        },
                        {
                            id: 'tabs-pills',
                            title: 'Tabs & Pills',
                            type: 'item',
                            userTypes: ['ADMIN'],
                            url: '/basic/tabs-pills'
                        },
                        {
                            id: 'typography',
                            title: 'Typography',
                            type: 'item',
                            userTypes: ['ADMIN'],
                            url: '/basic/typography'
                        }
                    ]
                }
            ]
        },
        {
            id: 'ui-forms',
            title: 'Forms & Tables',
            type: 'group',
            userTypes: ['ADMIN'],
            icon: 'icon-group',
            children: [
                {
                    id: 'forms',
                    title: 'Forms',
                    type: 'item',
                    userTypes: ['ADMIN'],
                    url: '/forms/form-basic',
                    icon: 'feather icon-file-text'
                },
                {
                    id: 'bootstrap',
                    title: 'Bootstrap Table',
                    type: 'item',
                    userTypes: ['ADMIN'],
                    url: '/tables/bootstrap',
                    icon: 'feather icon-server'
                }
            ]
        },
        {
            id: 'chart-maps',
            title: 'Chart & Maps',
            type: 'group',
            userTypes: ['ADMIN'],
            icon: 'icon-charts',
            children: [
                {
                    id: 'charts',
                    title: 'Charts',
                    type: 'item',
                    userTypes: ['ADMIN'],
                    url: '/charts/nvd3',
                    icon: 'feather icon-pie-chart'
                },
                {
                    id: 'maps',
                    title: 'Maps',
                    type: 'item',
                    userTypes: ['ADMIN'],
                    url: '/maps/google-map',
                    icon: 'feather icon-map'
                }
            ]
        },
        {
            id: 'pages',
            title: 'Pages',
            type: 'group',
            userTypes: ['ADMIN'],
            icon: 'icon-pages',
            children: [
                {
                    id: 'auth',
                    title: 'Authentication',
                    type: 'collapse',
                    userTypes: ['ADMIN'],
                    icon: 'feather icon-lock',
                    children: [
                        {
                            id: 'signup-2',
                            title: 'Sign UP (template)',
                            type: 'item',
                            userTypes: ['ADMIN'],
                            url: '/auth/signup-2',
                            target: true,
                            breadcrumbs: false
                        },
                        {
                            id: 'signin-2',
                            title: 'Sign IN (template)',
                            type: 'item',
                            userTypes: ['ADMIN'],
                            url: '/auth/signin-2',
                            target: true,
                            breadcrumbs: false
                        }
                    ]
                },
                {
                    id: 'sample-page',
                    title: 'Sample Page',
                    type: 'item',
                    userTypes: ['ADMIN'],
                    url: '/sample-page',
                    classes: 'nav-item',
                    icon: 'feather icon-sidebar'
                }
            ]
        },
        {
            id: 'resources',
            title: 'Resources',
            type: 'group',
            userTypes: ['ADMIN'],
            icon: 'icon-pages',
            children: [
                {
                    id: 'product-page',
                    title: 'Download Product',
                    type: 'item',
                    userTypes: ['ADMIN'],
                    url: 'https://appseed.us/product/react-node-js-datta-able',
                    classes: 'nav-item',
                    icon: 'feather icon-download',
                    target: true,
                    external: true
                },
                {
                    id: 'support',
                    title: 'Get Support',
                    type: 'item',
                    userTypes: ['ADMIN'],
                    icon: 'feather icon-help-circle',
                    classes: 'nav-item',
                    url: 'https://appseed.us',
                    target: true,
                    external: true
                }
            ]
        }        
    ]
};

export default menuItems;
